module.exports = __webpack_public_path__ + "img/misi.f9a3ba96.svg";